/**
 * Featured Collection — Horizontal Scroll
 * Mirror of the featured-blog hscroll logic:
 *   - Collapsing/emerging arrows (Brainmarket style)
 *   - Scrolls ~90% of visible width per click
 *   - Arrows swap: right visible initially, left appears after scrolling
 *   - Works with Shopify theme editor re-renders
 */
(function () {
  const SELECTOR = '[data-featured-collection-hscroll]';

  function init(root) {
    if (!root) return;

    // Avoid double binding
    if (root.dataset.hscrollInit === '1') return;
    root.dataset.hscrollInit = '1';

    const scroller = root.querySelector('[data-hscroll]');
    const prev = root.querySelector('.featured-collection__hscroll-arrow--prev');
    const next = root.querySelector('.featured-collection__hscroll-arrow--next');

    if (!scroller || !prev || !next) return;

    // Ensure horizontal scroll is possible
    scroller.style.overflowX = 'auto';

    const amount = () => Math.max(200, Math.floor(scroller.clientWidth * 0.9));

    // Helper: check if we can still scroll right
    const canScrollRight = () =>
      Math.ceil(scroller.scrollLeft + scroller.clientWidth) < scroller.scrollWidth - 2;

    const canScrollLeft = () => scroller.scrollLeft > 2;

    // ---- UPDATE ARROWS based on scroll position ----
    function updateArrows() {
      const left = canScrollLeft();
      const right = canScrollRight();

      if (left && prev.classList.contains('is-hidden')) {
        prev.classList.remove('is-hidden');
        prev.classList.add('pop-in');
        setTimeout(() => prev.classList.remove('pop-in'), 400);
      } else if (!left && !prev.classList.contains('is-hidden')) {
        prev.classList.add('is-hidden');
      }

      if (right && next.classList.contains('is-hidden')) {
        next.classList.remove('is-hidden');
        next.classList.add('pop-in');
        setTimeout(() => next.classList.remove('pop-in'), 400);
      } else if (!right && !next.classList.contains('is-hidden')) {
        next.classList.add('is-hidden');
      }
    }

    // ---- INITIAL STATE ----
    prev.classList.add('is-hidden');
    if (!canScrollRight()) {
      next.classList.add('is-hidden');
    } else {
      next.classList.remove('is-hidden');
    }

    // ---- NEXT CLICK ----
    next.addEventListener('click', function (e) {
      e.preventDefault();
      scroller.scrollBy({ left: amount(), behavior: 'smooth' });

      // Wait for scroll to settle, then update arrows
      setTimeout(updateArrows, 350);
    });

    // ---- PREV CLICK ----
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      scroller.scrollBy({ left: -amount(), behavior: 'smooth' });

      // Watch until scroll settles
      var last = -1;
      var stableFrames = 0;

      function watch() {
        var x = scroller.scrollLeft;

        if (Math.abs(x - last) < 0.5) stableFrames += 1;
        else stableFrames = 0;

        last = x;

        if (x <= 2 || stableFrames >= 6) {
          updateArrows();
          return;
        }

        requestAnimationFrame(watch);
      }

      requestAnimationFrame(watch);
    });

    // ---- Also update on manual scroll / touch swipe ----
    var scrollTimer;
    scroller.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateArrows, 100);
    }, { passive: true });
  }

  function boot(context) {
    var scope = context || document;
    scope.querySelectorAll(SELECTOR).forEach(init);
  }

  // Normal load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Theme editor: section re-render
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
